<script>
import svgParser from '@/tools/parser';
import * as d3 from 'd3';

export default {
    name: 'origins-area',
    components: {},
    props: {
        area: {
            type: Object,
            required: true
        },
        state: {
            type: Object,
            required: true
        }
    },
    computed: {
        isActive() {
            return this.area === this.state.currentArea;
        }
    },
    methods: {
        create() {
            let g = d3.select(this.$refs.g);
            svgParser.addIllustration(this.area.p, g);
        },
        select() {
            this.state.currentArea = this.area;
        }
    },
    mounted(){
        this.create();
    }
};
</script>


<template>
    <div
        @click="select()"
        :class="{'selected': isActive}"
        class="origins-area">
        <svg>
            <g ref="g"></g>
        </svg>
    </div>
</template>


<style lang="scss">
    @import '@/styles/variables.scss';

    .origins-area {
        cursor: pointer;
        width: 120px;

        .origins-highlight-area {
            fill: rgba(255,255,255,0.5);
        }

        &.selected {
            margin-top: 10px;

            .origins-highlight-area {
                fill: #FFCEDA!important;
            }
        }
    }
</style>